import { Entity, stringifyEntityRef } from '@backstage/catalog-model';

export const governanceAnnotations = {
  classificationSource: 'clrslate.io/classification-source',
  currentImage: 'clrslate.io/current-image',
  currentVersion: 'clrslate.io/current-version',
  hostingModel: 'clrslate.io/hosting-model',
  namespace: 'clrslate.io/kubernetes-namespace',
  primaryContainer: 'clrslate.io/primary-container',
  softwareOrigin: 'clrslate.io/software-origin',
  upstreamUrl: 'clrslate.io/upstream-url',
  workloadName: 'clrslate.io/workload-name',
} as const;

export type GovernanceClassification = {
  softwareOrigin: string;
  hostingModel: string;
  source: string;
  upstreamUrl?: string;
};

export function classificationFromEntity(
  entity: Entity,
): GovernanceClassification {
  const annotations = entity.metadata.annotations ?? {};
  return {
    softwareOrigin:
      annotations[governanceAnnotations.softwareOrigin] ?? 'unknown',
    hostingModel:
      annotations[governanceAnnotations.hostingModel] ?? 'not-applicable',
    source:
      annotations[governanceAnnotations.classificationSource] ?? 'inferred',
    upstreamUrl: annotations[governanceAnnotations.upstreamUrl],
  };
}

export function governanceStatusPath(entity: Entity): string {
  const namespace = entity.metadata.namespace ?? 'default';
  return `/v1/entities/${encodeURIComponent(
    entity.kind.toLocaleLowerCase('en-US'),
  )}/${encodeURIComponent(namespace)}/${encodeURIComponent(
    entity.metadata.name,
  )}/status`;
}

export function entityRef(entity: Entity): string {
  return stringifyEntityRef(entity);
}

export function isComponent(entity?: Entity): entity is Entity {
  return entity?.kind.toLocaleLowerCase('en-US') === 'component';
}

export function isRuntimeComponent(entity?: Entity): boolean {
  return (
    isComponent(entity) &&
    Boolean(entity.metadata.annotations?.[governanceAnnotations.namespace])
  );
}

export function label(value: string): string {
  return value
    .split('-')
    .filter(Boolean)
    .map(part => part.charAt(0).toLocaleUpperCase('en-US') + part.slice(1))
    .join(' ');
}
